import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["productLine", "skuId", "additionalUnitSkuId", "additionalUnitQuantity", "purchaseMotion", "termOverride", "screen", "trackingSource", "use", "sourceId"];
import CodeSplitEnvWrapper from 'pricing-pages-ui/components/common/env/CodeSplitEnvWrapper';
import { productForSkuIdSelector, upgradeProductSelector } from 'pricing-pages-ui/selectors/ProductsSelectors';
import { productLineToHub } from 'self-service-api/constants/ProductLineToHub';
import { SCREENS } from '../../../constants/tracking/Screens';
import { APP } from '../../../constants/tracking/TrackingSources';
import { useAppSelector } from '../../../reducers';
import { isAppAuthSelector } from '../../../selectors/AuthSelectors';
import { checkoutProductConfigurationsSelector, productVersionConfigsWithUnitsSelector } from '../../../selectors/ProductConfigsSelectors';
import { useQueryParamTerm } from '../../../utils/urls/appQueryParamUtils';
import LoadingCTA from './LoadingCTA';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * This component houses the logic used for rendering a CTA for the core hub product, i.e. Marketing Hub, Sales Hub, Service Hub, etc. It is often used in conjunction with useHubPurchaseMotions
 */
const HubProductCTA = _ref => {
  let {
      productLine,
      skuId,
      additionalUnitSkuId,
      additionalUnitQuantity,
      purchaseMotion,
      termOverride,
      screen = SCREENS.PRODUCTS_PLANS,
      trackingSource,
      use = 'primary',
      sourceId = trackingSource
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const apiName = useAppSelector(state => {
    return productForSkuIdSelector(state, {
      skuId
    }).apiName;
  });
  const upgradeProduct = useAppSelector(state => upgradeProductSelector(state, {
    skuIds: [skuId]
  }));
  const isAppAuth = useAppSelector(isAppAuthSelector);
  const productConfigurations = useAppSelector(state => checkoutProductConfigurationsSelector(state, {
    productConfigurations: productVersionConfigsWithUnitsSelector(state, {
      skuId,
      additionalUnitQuantity,
      additionalUnitSkuId
    }),
    subtractOwnedUnitsIfBuyingNoAdditional: isAppAuth,
    subtractOwnedSeats: isAppAuth
  }));
  const {
    queryParamTerm
  } = useQueryParamTerm();

  // In the case we pass in purchaseMotion by indexing purchaseMotions[0], but the purchaseMotions array is empty. TS won't complain, but it will throw an error at runtime.
  if (!purchaseMotion) return null;
  const upgradeData = {
    app: APP,
    screen,
    uniqueId: `${trackingSource}-${upgradeProduct}`,
    upgradeProduct
  };
  const sharedProps = Object.assign({
    productConfigurations,
    queryParamTerm: termOverride !== null && termOverride !== void 0 ? termOverride : queryParamTerm,
    trackingSource,
    // for legacy tracking
    purchaseMotion,
    use
  }, rest);
  return /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
    authedComponentLoader: () => import( /* webpackChunkName: "authed-chunk" */`pricing-pages-ui/components/common/purchaseMotions/PurchaseMotionButtonWrapper`),
    publicComponentLoader: () => import( /* webpackChunkName: "public-chunk" */`pricing-pages-ui/features/purchaseMotions/components/PublicPurchaseMotionButton`),
    authedComponentProps: Object.assign({}, sharedProps, {
      upgradeData,
      fallbackSeleniumIdentifier: apiName
    }),
    publicComponentProps: Object.assign({}, sharedProps, {
      sourceId,
      dtbSource: `pricing-page|${productLineToHub[productLine]}-hub|${trackingSource}|${upgradeProduct}`
    }),
    publicComponentLoadingState: LoadingCTA,
    authedComponentLoadingState: LoadingCTA
  });
};
export default HubProductCTA;